<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="combustibles"
      item-key="id"
      :sort-by="[{ key: 'fecha_hora', order: 'desc' }]"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Gastos de Combustible</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="openDialogForNew">
            Nueva Carga
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha_hora`]="{ item }">
        {{ moment(item.fecha_hora).format('DD/MM/YYYY HH:mm') }}
      </template>

      <template v-slot:[`item.auto`]="{ item }">
        <span v-if="item.auto">{{ item.auto.placa }}</span>
        <span v-else class="text-grey">—</span>
      </template>

      <template v-slot:[`item.tipo`]="{ item }">
        {{ item.tipo_combustible?.descripcion }}
      </template>

      <template v-slot:[`item.grifo`]="{ item }">
        {{ item.grifo?.descripcion || '—' }}
      </template>

      <template v-slot:[`item.kilometraje`]="{ item }">
        {{ Number(item.kilometraje).toLocaleString('es-PE') }} km
      </template>

      <template v-slot:[`item.galones`]="{ item }">
        {{ Number(item.galones).toFixed(3) }}
      </template>

      <template v-slot:[`item.monto`]="{ item }">
        <v-chip color="primary" size="small">S/ {{ Number(item.monto).toFixed(2) }}</v-chip>
      </template>

      <template v-slot:[`item.precioGalon`]="{ item }">
        <span v-if="Number(item.galones) > 0">
          S/ {{ (Number(item.monto) / Number(item.galones)).toFixed(2) }}
        </span>
        <span v-else class="text-grey">—</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon size="small" color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <CombustibleDialog
      :dialog="dialog"
      :editedItem="editedItem"
      :formTitle="formTitle"
      :autos="autos"
      :tiposCombustible="tiposCombustible"
      :grifos="grifos"
      @update:dialog="dialog = $event"
      @save="saveDialog"
    />

    <v-dialog v-model="dialogDelete" width="auto" persistent>
      <v-card max-width="400" prepend-icon="mdi-delete" title="Eliminar Carga"
        text="¿Está seguro de eliminar esta carga de combustible?">
        <template v-slot:actions>
          <v-spacer />
          <v-btn color="blue-darken-1" text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="red-darken-1" text @click="deleteItemConfirm">Eliminar</v-btn>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import CombustibleDialog from '@/components/gasto/CombustibleDialog.vue';

export default {
  components: { CombustibleDialog },
  data() {
    return {
      moment,
      dialog: false,
      dialogDelete: false,
      headers: [
        { title: 'Fecha', value: 'fecha_hora' },
        { title: 'Auto', value: 'auto' },
        { title: 'Tipo', value: 'tipo' },
        { title: 'Grifo', value: 'grifo' },
        { title: 'Kilometraje', value: 'kilometraje' },
        { title: 'Galones', value: 'galones' },
        { title: 'Monto', value: 'monto' },
        { title: 'S/ x Galón', value: 'precioGalon' },
        { title: 'Acciones', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {},
    };
  },
  computed: {
    ...mapGetters('gasto', [
      'combustibles',
      'tiposCombustible',
      'grifos',
      'autos',
    ]),
    formTitle() {
      return this.editedIndex === -1 ? 'Nueva Carga de Combustible' : 'Editar Carga';
    },
  },
  async created() {
    await Promise.all([
      this.fetchTiposCombustible(),
      this.fetchGrifos(),
      this.fetchAutosForGasto(),
    ]);
    this.recargar();
  },
  methods: {
    ...mapActions('gasto', [
      'fetchCombustibles',
      'getCombustibleById',
      'guardarCombustible',
      'updateCombustible',
      'deleteCombustible',
      'fetchTiposCombustible',
      'fetchGrifos',
      'fetchAutosForGasto',
    ]),
    recargar() {
      this.fetchCombustibles();
    },
    openDialogForNew() {
      this.editedItem = {};
      this.editedIndex = -1;
      this.dialog = true;
    },
    async editItem(item) {
      const c = await this.getCombustibleById(item.id);
      this.editedItem = c;
      this.editedIndex = this.combustibles.findIndex(x => x.id === item.id);
      this.dialog = true;
    },
    confirmDelete(item) {
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      await this.deleteCombustible(this.editedItem.id);
      this.dialogDelete = false;
    },
    async saveDialog(item) {
      const action = item.id ? this.updateCombustible : this.guardarCombustible;
      await action(item);
      this.dialog = false;
      this.recargar();
    },
  },
};
</script>
